module.exports = __webpack_public_path__ + "img/195.cc75c96e.jpg";